<template>
    <div class="createMtt">
        <div v-show="headShow" class="content-title">
              <el-radio-group v-model="form.gameType">
                  <el-radio-button label="积分赛" @click="gameSetShow = true"></el-radio-button>
                  <el-radio-button label="实物赛" @click="gameSetShow = false"></el-radio-button>
              </el-radio-group>
              <el-button @click="createMtt" style="float:right" type="success">确认创建</el-button>
          </div>
          <div class="content-body">
              <div v-show="gameSetShow" class="integral">
                  <div class="content-condition">
                      <div class="condition-item">
                          <div class="title">赛事名称</div>
                          <el-input class="ci-input" v-model="form.matchName" placeholder="请输入少于15个汉字"></el-input>
                      </div>
                      <div class="condition-item">
                          <div class="title">开赛时间</div>
                          <el-date-picker
                              class="ci-input"
                              v-model="form.time"
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="选择日期时间">
                          </el-date-picker>
                          <el-tooltip class="item" effect="light" content="请将开赛时间设置为5分钟以后" placement="top-start">
                              <div class="icon-question">?</div>
                          </el-tooltip>
                      </div>
                      <div class="condition-item">
                          <div class="title">盲注表类型</div>
                          <el-radio-group @change="blindTypeChange" v-model="form.blindTypeLabel">
                              <el-radio-button label="快速盲注" value="1"></el-radio-button>
                              <el-radio-button label="普通盲注" value="0"></el-radio-button>
                          </el-radio-group>
                          <div class="icon-question" @click="centerDialogVisible = true">?</div>
                      </div>
                  </div>
                  <div class="content-main">
                      <el-card class="box-card">
                          <div class="block">
                              基础设置
                          </div>
                          <div class="block">
                             <el-card class="box-card">
                                 <div>
                                     报名费：{{form.registationFee}}
                                 </div>
                                 <el-slider v-model.Number="form.registationFee" :max="10000" show-input @keyup.native="number($event)"></el-slider>
                              </el-card>
                              <el-card class="box-card">
                                  <div>
                                     升盲时间：{{form.updateBlindTime}}分钟
                                 </div>
                                 <el-slider v-model="form.updateBlindTime" :max="30" show-input  @keyup.native="number($event)"></el-slider>
                              </el-card>
                              <el-card class="box-card">
                                  <div>
                                     起始记分牌：{{form.initialScore}}（{{Number(form.initialScore/20)}}BB）
                                 </div>
                                 <el-slider :step="100" :show-stops='true' v-model="form.initialScore" :max="10000" show-input  @keyup.native="number($event)"></el-slider>
                              </el-card>
                              <el-card class="box-card">
                                  <div>
                                     参赛人数上限：{{form.upperLimitPlayers}}
                                 </div>
                                 <el-slider v-model="form.upperLimitPlayers" :max="10000" show-input  @keyup.native="number($event)"></el-slider>
                              </el-card>
                              <el-card class="box-card">
                                  <div>
                                     参赛人数下限：{{form.lowerLimitPlayers}}
                                 </div>
                                 <el-slider v-model="form.lowerLimitPlayers" :max="10000" show-input  @keyup.native="number($event)"></el-slider>
                              </el-card>
                          </div>
                      </el-card>
                      <el-card class="box-card">
                          <div class="block">
                              <div style="margin-right:15px;">高级设置</div>
                              <el-switch
                              v-model="advancedSetting"
                              active-color="#13ce66"
                              inactive-color="#ff4949">
                              </el-switch>
                          </div>
                          <div class="block" v-show="advancedSetting">
                             <el-card class="box-card">
                                 <div>
                                     重构次数：{{form.allowRebuyTimes}}
                                 </div>
                                 <div class="item-info">
                                     <el-slider style="width:90%" v-model="form.allowRebuyTimes" :max="90" show-input  @keyup.native="number($event)"></el-slider>
                                      <el-tooltip class="item" effect="light" content="每次购买1倍记分牌" placement="top-start">
                                          <div class="icon-question">?</div>
                                      </el-tooltip>
                                 </div>
                              </el-card>
                              <el-card class="box-card">
                                  <div>
                                     延迟报名盲注级别：{{form.allowDelayMaxBlindLevel}}
                                 </div>
                                 <el-slider v-model="form.allowDelayMaxBlindLevel" :max="15" show-input  @keyup.native="number($event)"></el-slider>
                              </el-card>
                              <el-card class="box-card">
                                <div class="c-item">
                                  <div>
                                     截止重购盲注级别：{{form.allowRebuyMaxBlindLevel}}
                                 </div>
                                 <el-slider v-model="form.allowRebuyMaxBlindLevel" :max="39" show-input  @keyup.native="number($event)"></el-slider>
                                </div>
                              </el-card>
                              <el-card class="box-card big-b">
                                  <div class="c-item">
                                     <div style="margin-right:15px;">设置配置</div>
                                     <el-checkbox-group @change="controlChange" v-model="form.control">
                                          <el-checkbox label="GPS限制"></el-checkbox>
                                          <el-checkbox label="IP控制"></el-checkbox>
                                      </el-checkbox-group>
                                 </div>
                                 <div class="c-item">
                                     <div style="margin-right:30px;">猎人赛</div>
                                     <el-switch
                                      v-model="form.isHuntsmanMatch"
                                      active-value="1"
                                      inactive-value="0"
                                      active-text="开"
                                      inactive-text="">
                                      </el-switch>
                                 </div>
                                 <div class="c-item">
                                     <div style="margin-right:15px;">赏金比例</div>
                                     <el-input style="width:120px" placeholder="请输入比例" v-model="form.huntsmanBonusPercent"  @keyup.native="number($event)">
                                          <template slot="append">%</template>
                                     </el-input>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                     <div style="margin-right:15px;">延迟报名比例</div>
                                       <el-input style="width:120px" placeholder="请输入比例" v-model="form.serviceFee"  @keyup.native="number($event)">
                                         <template slot="append">%</template>
                                       </el-input>
                                 </div>
                              </el-card>
                            <el-card class="box-card big-b">
                              <div class="c-item">
                                <div style="margin-right:15px;">
                                  <tr>
                                    <td>机器人个数：</td>
                                    <td>
                                      <el-input style="width:120px" placeholder="机器人个数" v-model="form.aiCount"  @keyup.native="number($event)"/>
                                    </td>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <td>剩余机器人个数：{{form.useAiCount}}</td>
                                  </tr>
                                </div>
                              </div>
                              <div class="c-item">
                                <tr>
                                  <td >机器人类型：</td>
                                  <td>
                                    <el-select size="medium" v-model="form.aiState" @change="getMttViewAtCount()">
                                      <el-option
                                          v-for="item of aiStateArray"
                                          :key="item.label"
                                          :label="item.label"
                                          :value="item.value"/>
                                    </el-select>
                                  </td>
                                </tr>
                              </div>
                            </el-card>
                            <el-card class="box-card big-b">
                              <div class="c-item">
                                <div style="margin-right:15px;">
                                  <el-button @click="rowClick()" style="float:right" type="primary">设置比赛奖励</el-button>
                                </div>
                              </div>
                              <div class="c-item">
                                <div style="margin-right:15px;">
                                  <el-button @click="rowMangZhuClick()" style="float:right" type="primary">设置比赛盲注</el-button>
                                </div>
                              </div>
                            </el-card>
                          </div>
                      </el-card>
                  </div>
              </div>
              <div v-show="rewardList" class="integral">
                <reward-mtt v-bind:rewardList="rewardList"
                            v-on:editRewardList="updateRewardVo($event)"/>
              </div>
              <div  v-show="mangZhuGradeShow.showType" class="integral">
                <mang-zhu-grade v-bind:mangZhuGradeShow="mangZhuGradeShow"
                                v-on:editBindNoteGradeList="editBindNoteGradeList($event)"/>
              </div>
          </div>
          <el-dialog title="锦标赛盲注表" :visible.sync="centerDialogVisible" width="400px" center>
              <el-tabs v-model="blindTableActiveName" type="card">
                  <el-tab-pane label="普通盲注表" name="first">
                      <el-table :data="normalBlindList" border style="width: 100%">
                          <el-table-column prop="grade" label="级别">

                          </el-table-column>
                          <el-table-column prop="mangzhu" label="盲注" width="180">
                            <template slot-scope="scope">{{scope.row.mangzhu|numberChip}}</template>
                          </el-table-column>
                          <el-table-column prop="qianzhu" label="前注">
                            <template slot-scope="scope">{{scope.row.qianzhu|numberChip}}</template>
                          </el-table-column>
                      </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="快速盲注表" name="second">
                      <el-table :data="quickBlindList" border style="width: 100%">
                          <el-table-column prop="grade" label="级别"> </el-table-column>
                          <el-table-column prop="mangzhu" label="盲注" width="180">
                            <template slot-scope="scope">{{scope.row.mangzhu|numberChip}}</template>
                          </el-table-column>
                          <el-table-column prop="qianzhu" label="前注">
                            <template slot-scope="scope">{{scope.row.qianzhu|numberChip}}</template>
                          </el-table-column>
                      </el-table>
                  </el-tab-pane>
              </el-tabs>
              <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
              </span>
          </el-dialog>
    </div>
</template>
<script>
    import { mapActions} from 'vuex'
    import utils from '../../../utils/util'
    import rewardMtt from "./rewardMtt";
    import mangZhuGrade from "./mangZhuGrade";
    export default {
        components:{
          rewardMtt,
          mangZhuGrade,
        },
        data() {
          return {
              loading: false,
              headShow: true,
              gameSetShow: true,
              rewardList: false,
              mangZhuGradeShow: {
                showType:false,
                gameType:0,
              },
              centerDialogVisible:false,
              date: null,
              searchVal: '',
              configInfo:{},
              currentPage: 1,
              form:{
                "blindTypeLabel":'快速盲注',
                "advancedEntryTimes": 0,
                "allowDelayMaxBlindLevel": 15,
                "allowRebuyMaxBlindLevel": 12,
                "allowRebuyTimes": 1,
                "blindType": 0,
                "creatorID": 0,
                "creatorName": "",
                "entryTime": "",
                "gameIcon": "",
                "gameType": '积分赛',
                "huntsmanBonusPercent": 30,
                // "initialChip": 0,
                "initialScore": 200,
                "isAllowAppend": 0,
                "isAllowDelay": 0,
                "isAllowRebuy": 0,
                "isGpsLimit": 0,
                "isHuntsmanMatch": "1",
                "isIpLimit": 0,
                "isVirtual": 0,
                "lowerLimitPlayers": 0,
                "matchName": "",
                "prizeIcon": "",
                "prizeName": "",
                "registationFee": 50,
                "roomNumType": 9,
                "sbChip": 10,
                "serviceFee": 0,
                "showTime": "",
                "startTime": "",
                "updateBlindTime": 2,
                "upperLimitPlayers": 200,
                "voucherId": 0,
                "aiCount": 0,
                "control":[],
                "aiState":0,
                "useAiCount":0,
                "time":''
              },
              aiStateArray: [{
                label: '随机',
                value: 0
              },{
                label: '中小级别盈利型',
                value: 1
              },{
                label: '中小级别均衡型',
                value: 2
              }, {
                label: '中小级别大鱼型',
                value: 3
              },{
                label: '大级别盈利型',
                value: 4
              },{
                label: '大级别均衡型',
                value: 5
              },{
                label: '大级别大鱼型',
                value: 6
              }],
              quickBlindList:[],
              normalBlindList:[],
              advancedSetting:true,
              blindTableActiveName:'first',

            }
        },
        computed: {
            userType() {
                return localStorage.getItem('authTypeCode')
            }
        },
        created() {
          this.getMangZhuList();
          this.getMttViewAtCount();
        },
        methods: {
            ...mapActions('mtt', [ 'createMttApi','mttMangZhuList','mttViewAtCount']),
            getMangZhuList(){
              this.mttMangZhuList().then(res=>{
                this.normalBlindList=res.data.normalBlindList;
                this.quickBlindList=res.data.quickBlindList;
              })
            },
            getMttViewAtCount(){
              this.mttViewAtCount(this.form.aiState).then(res=>{
                this.form.useAiCount=res.data;
              })
            },
            rowClick() {
              this.rewardList=true;
              this.gameSetShow=false;
              this.headShow=false;
            },
            updateRewardVo(val){
              this.rewardList=val;
              this.gameSetShow=true;
              this.headShow=true;
            },

            rowMangZhuClick() {
              var type=0;
              if (this.form.blindTypeLabel==='快速盲注'){
                type=1;
              }
              this.mangZhuGradeShow.showType=true;
              this.mangZhuGradeShow.gameType=type;
              this.gameSetShow=false;
              this.headShow=false;
            },
            editBindNoteGradeList(val){
              this.mangZhuGradeShow.showType=val;
              this.gameSetShow=true;
              this.headShow=true;
            },
            // 创建mtt
            createMtt(obj = {}) {
                this.loading = true;
                if(this.form.allowRebuyTimes>0){
                    this.form.isAllowRebuy = 1;
                }
                if(this.form.allowDelayMaxBlindLevel>0){
                    this.form.isAllowDelay = 1;
                }
                if(this.form.gameType == '积分赛'){
                    this.form.gameType = 1;
                }else{
                    this.form.gameType = 2;
                }
                if(utils.getByteLen(this.form.gameType) > 15) {
                    this.$message.error('开局成功');
                    return;
                }
                var blindLabel=0;
                if (this.form.blindTypeLabel==='快速盲注'){
                  blindLabel=1;
                }
                this.form.blindType=blindLabel;
                this.form.creatorID = localStorage.userId;
                this.form.creatorName = localStorage.nickname;
                this.form.entryTime = Number(new Date(this.form.time).getTime()/1000);
                this.form.showTime = Number(new Date(this.form.time).getTime()/1000);
                this.form.startTime = Number(new Date(this.form.time).getTime()/1000);
                this.form.serviceFee = (this.form.serviceFee*this.form.registationFee);
                let params = this.form;
                params.aiType=this.form.aiState;
                Object.assign(params, obj);
                this.createMttApi(params).then(() => {
                    this.$message.success('开局成功')
                    this.getMttViewAtCount();
                    this.loading = false;
                })
            },
            controlChange(){
                var index = this.form.control.toString();
                if(index.indexOf('GPS限制')>=0){
                    this.form.isGpsLimit = 1;
                }else{
                    this.form.isGpsLimit = 0;
                }

                if(index.indexOf('IP限制')>=0){
                    this.form.isIpLimit = 1;
                }else{
                    this.form.isIpLimit = 0;
                }
            },
            blindTypeChange(){
                var index = this.form.blindTypeLabel.toString();
                console.log(index)
                if(index === '快速盲注'){
                    this.form.blindType = 1;
                }else{
                    this.form.blindType = 0;
                }
                this.mangZhuGradeShow.gameType=this.form.blindType;
            },
            number(e){
                console.log(e.target.value);
                let flag=new RegExp("^[1-9]([0-9])*$").test(e.target.value);
                console.log(flag);
                if(!flag){
                    this.$message({
                        showClose:true,
                        message:"请输入正整数",
                        type:"warning"
                    });
                    e.target.value = e.target.value.split('.')[0];
                }
            }
        },
    }
</script>
<style lang="scss">
    .createMtt{
        .content-title{
            text-align: center;
        }
        .content-body{
            width: 100%;
            .integral{
                width: 100%;
                .content-condition{
                    width: 100%;
                    display: flex;
                    padding: 30px 0;
                    .condition-item{
                        margin: 0 30px 0 0;
                        width: 30%;
                        display: flex;
                        align-items: center;
                        justify-content: left;
                        .title{
                            width: 85px;
                            display: flex;
                            align-items: center; 
                        }
                        .ci-input{
                            width: 60% !important;
                        }
                    }
                }
                .content-main{
                    .block{
                        display: flex;
                        flex-wrap: wrap;  
                        .box-card{
                            width: 45%;
                            margin: 15px;
                            .item-info {
                                display: flex;
                                align-items: center;
                            }
                        } 
                        .big-b{
                            width: 45%;
                            margin: 15px;
                            .c-item{
                                display: flex;
                                align-items: center;
                                margin:0 0 15px 0;
                            }
                        }  
                    }
                }
            }
        }
    }
    
</style>
<style>
    .icon-question {
        border: 1px solid black;
        border-radius: 20px;
        height: 20px;
        margin-left: 10px;
        width: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        color: black;
        font-size: 20px;
    }
</style>